/**
 * Stub: KeywordEngineResultsDisplay exports are not available in the admin app.
 * This stub exists so that @a7y/ui EngineDetailKeyword can be resolved by the bundler.
 */
export const StatCard = () => null;
export const CollapsibleSection = () => null;
export const ScoreBadge = () => null;
export const RankBadge = () => null;
export const CompetitorRanks = () => null;
// eslint-disable-next-line react-refresh/only-export-components
export function buildCompetitorMetadataMap(): unknown {
  return {};
}
